import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Spinner } from 'react-bootstrap';
import { api } from "../../../services/api";
import Swal from "sweetalert2";
import { FaTrashAlt, FaExclamationTriangle } from "react-icons/fa";

export default function ModalExcluirMovimento({ show, onHide, onSuccess }) {
    const [loading, setLoading] = useState(false);
    const [roteamentos, setRoteamentos] = useState([]);
    
    // Inicializa com a data local do sistema sem usar ISOString (que causa o erro de fuso)
    const dataHoje = new Date().toLocaleDateString('en-CA'); // Retorna YYYY-MM-DD
    const [filtros, setFiltros] = useState({
        dtini: dataHoje,
        dtfim: dataHoje,
        roteamento: ''
    });

    // CORREÇÃO DA DATA: Manipulação de string pura para evitar o erro de fuso horário
    const formatarDataParaBR = (dataIso) => {
        if (!dataIso) return '';
        const partes = dataIso.split('-'); // ["2026", "02", "25"]
        if (partes.length !== 3) return dataIso;
        return `${partes[2]}/${partes[1]}/${partes[0]}`; // "25/02/2026"
    };

    useEffect(() => {
        if (show) {
            api.get('/financeiro/conciliacao/roteamentos')
                .then(res => setRoteamentos(res.data))
                .catch(err => console.error("Erro ao carregar roteamentos:", err));
        }
    }, [show]);

    const handleExcluir = async () => {
        const confirm = await Swal.fire({
            title: 'TEM CERTEZA?',
            text: `Isso excluirá os movimentos de ${formatarDataParaBR(filtros.dtini)} até ${formatarDataParaBR(filtros.dtfim)} ${filtros.roteamento ? 'para ' + filtros.roteamento : ''}.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'SIM, EXCLUIR!',
            cancelButtonText: 'Cancelar'
        });

        if (!confirm.isConfirmed) return;

        setLoading(true);
        try {
            await api.delete('/financeiro/conciliacao/movimento', {
                params: {
                    dtini: formatarDataParaBR(filtros.dtini),
                    dtfim: formatarDataParaBR(filtros.dtfim),
                    roteamento: filtros.roteamento
                }
            });

            await Swal.fire("Excluído!", "Os movimentos foram removidos.", "success");
            if (onSuccess) onSuccess();
            onHide();
        } catch (err) {
            Swal.fire("Erro", err.response?.data?.erro || "Erro ao excluir", "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered backdrop="static">
            <Modal.Header closeButton className="bg-danger text-white p-2">
                <Modal.Title className="small fw-bold ms-2">
                    <FaTrashAlt className="me-2" /> EXCLUIR MOVIMENTOS
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="bg-light">
                <div className="alert alert-warning d-flex align-items-center small py-2">
                    <FaExclamationTriangle className="me-2 fs-4" />
                    <div>Apenas importações serão excluídas. Lançamentos manuais permanecem.</div>
                </div>

                <Form>
                    <Row className="g-3">
                        <Col md={6}>
                            <Form.Label className="small fw-bold">Data Início</Form.Label>
                            <Form.Control
                                type="date"
                                size="sm"
                                value={filtros.dtini}
                                onChange={e => setFiltros({ ...filtros, dtini: e.target.value })}
                            />
                        </Col>
                        <Col md={6}>
                            <Form.Label className="small fw-bold">Data Fim</Form.Label>
                            <Form.Control
                                type="date"
                                size="sm"
                                value={filtros.dtfim}
                                onChange={e => setFiltros({ ...filtros, dtfim: e.target.value })}
                            />
                        </Col>
                        <Col md={12}>
                            <Form.Label className="small fw-bold">Roteamento (Opcional)</Form.Label>
                            <Form.Select
                                size="sm"
                                value={filtros.roteamento}
                                onChange={e => setFiltros({ ...filtros, roteamento: e.target.value })}
                            >
                                <option value="">Todos os Roteamentos</option>
                                {roteamentos.map((r, i) => {
                                    // Pega o valor independente do case (minúsculo ou maiúsculo)
                                    const valor = r.roteamento || r.ROTEAMENTO || r;
                                    return (
                                        <option key={i} value={valor}>{valor}</option>
                                    );
                                })}
                            </Form.Select>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>

            <Modal.Footer className="bg-light border-top-0">
                <Button variant="secondary" size="sm" onClick={onHide}>CANCELAR</Button>
                <Button variant="danger" size="sm" onClick={handleExcluir} disabled={loading}>
                    {loading ? <Spinner size="sm" /> : 'CONFIRMAR EXCLUSÃO'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}